import lekhaSamitiData from "../../temp/lekhaSamiti.json";
import Footer from "../../components/Footer/Footer";

import "./LekhaSamitiPage.css";

function LekhaSamitiPage() {
  return (
    <div className="lekha-samiti">
      <div className="lekha-samiti__content">
        {lekhaSamitiData?.data?.map((el) => {
          return (
            <div className="lekha-samiti__member" id={el.id} key={el.id}>
              <img className="lekha-samiti__image" src={el.image} alt="kj" />
              <h3 className="lekha-samiti__heading">{el.post}</h3>:
              <p className="lekha-samiti__para"> {el.name}</p>
            </div>
          );
        })}
      </div>
      <Footer></Footer>
    </div>
  );
}

export default LekhaSamitiPage;
